import template from "./template.html";
import config from "../config";

export default function (editor) {
  const { DomComponents, BlockManager } = editor;

  DomComponents.addType("features-image", {
    isComponent: (el: HTMLElement) => el.classList && el.classList.contains("solo-landing-features-image"),
    model: {
      defaults: {
        draggable: true,
        removable: true,
        selectable: true,
        hoverable: true,
        stylable: ["background-color"],
      },
    },
  });

  BlockManager.add("features-image", {
    ...config,
    label: "Title, text, features and image aside",
    content: template,
  });
}
